
export default {
    namespaced: true,
    state: {
        lessons: []
    },

    actions: {
        fetchAll ({ commit }, { centerId, userName, courseId, fromDate, toDate }) {
            return window.axios.get(`/center/${centerId}/manager/${userName}/get-lesson`, { 
                params: { 
                    fromDate, 
                    toDate,
                    courseId, 
                }
            }).then(({ data }) => {
                return data
            })
        },
        createOrUpdate ({ commit }, { centerId, userName, homeWorkRequest }) {
            return window.axios.post(`center/${centerId}/manager/${userName}/add-update-lesson`,  homeWorkRequest).then(({ data }) => {
                return data
            })
        },

        delete ({ commit }, { centerId, userName, homeWorkId, courseId }) {
            return window.axios.post(`/center/${centerId}/manager/${userName}/delete-lesson`, {}, { params: { homeWorkId, courseId } }).then((data) => {
                return data
            })
        }
    },

    mutations: {
    }
}